import { Navigate, Outlet } from "react-router-dom";
import { adminStorage } from "../../features/admin/service";

const AdminRoute: React.FC = () => {
  const token = adminStorage.getToken();
  const user = adminStorage.getUser();

  if (!token || !user) {
    return <Navigate to="/admin/login" replace />;
  }

  return <Outlet />;
};

export default AdminRoute;
